import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./containers/App/App";
import { ConfigProvider, ThemeConfig } from "antd";
import RotationPrompt from './RotationPrompt';

const root = ReactDOM.createRoot(document.getElementById("root"));

const config: ThemeConfig = {
  token: {
    colorPrimary: "#3E55A4",
    environment: "STAGING",
  },
};
root.render(
  // <React.StrictMode>
      // {console.log("inside")}
    <ConfigProvider theme={config}>
      <App />
      <RotationPrompt />
    </ConfigProvider>
  // </React.StrictMode>
);
